import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, CircularProgress, InputAdornment, SxProps, TextField, Theme } from '@mui/material';
import { useQuery } from '@parkchirp/api-client';
import { FC } from 'react';

import { LIST_VEHICLE_MAKES } from '../../queries';

export const MakeAutocomplete: FC<{
	make: { id: number; name: string } | null;
	setMake: (make: { id: number; name: string } | null) => void;
	setModel: (model: { id: number; name: string } | null) => void;
	showLabel?: boolean;
	label?: string;
	disabled?: boolean;
	size?: 'small' | 'medium';
	sx?: SxProps<Theme>;
}> = ({ make, setMake, setModel, showLabel = true, label = 'Select Make', disabled = false, sx, size }) => {
	const { data, loading } = useQuery<{
		listVehicleMakes: {
			data: {
				id: number;
				name: string;
			}[];
		};
	}>(LIST_VEHICLE_MAKES, {
		context: {
			apiVersion: 'v2',
			public: true,
		},
	});

	return (
		<Autocomplete
			fullWidth
			size={size}
			options={data?.listVehicleMakes?.data ?? []}
			getOptionLabel={(o) => o.name}
			loading={loading}
			renderInput={(params) => (
				<TextField
					{...params}
					label={showLabel ? label : undefined}
					InputProps={{
						...params.InputProps,
						startAdornment: (
							<>
								<InputAdornment position='start'>
									<SearchIcon />
								</InputAdornment>
								{params.InputProps.startAdornment}
							</>
						),
					}}
					placeholder='Search for Make'
				/>
			)}
			value={make}
			onChange={(_, newMake) => {
				setModel(null);
				setMake(newMake);
			}}
			disabled={disabled}
			{...(sx && { sx })}
		/>
	);
};
